define('lq/queryDispatcher',[
    'jquery',
    'underscore',
    'lq/events/processEventActionsUrl'
], function ($, _, processEventActionsUrl) {
    'use strict';

    var QueryDispatcher = function (piping) {
        this.piping = piping;
    };

    QueryDispatcher.getDefaultQueryParams = function () {
        return {};
    };

    QueryDispatcher.prototype.getDefaultQueryParams = function () {
        return QueryDispatcher.getDefaultQueryParams();
    };

    QueryDispatcher.prototype.getQueryRequest = function (batch) {
        var self = this;
        return {
            actionId: this.piping.actionId,
            globalParameters: this.piping.parameters.globals.getAll(),
            localParameters: this.piping.parameters.locals.getAll(),
            requests: _.map(batch, function (batchEntry) {
                var queryData = self.getDefaultQueryParams();

                if (typeof batchEntry.decorateDataFunc === 'function')
                    batchEntry.decorateDataFunc(queryData);

                return {
                    eventActionType: 'ExecuteQuery',
                    actionId: self.piping.actionId,
                    rootMorphId: self.piping.actionId,
                    queryObjectName: batchEntry.queryName,
                    queries: [
                        {
                            listeners: [],
                            params: queryData
                        }
                    ],
                    eventActionId: 0
                };
            })
        };
    };

    QueryDispatcher.prototype.dispatchBatch = function (batch) {
        var requestData = this.getQueryRequest(batch);

        this.piping.dispatcher
            .dispatch(processEventActionsUrl.get(this.piping, 'Queries'), requestData, function (batchResult) {
                _.each(batchResult.responses, function (response, i) {
                    var handler = batch[i].handler;
                    var result = response.Results[0].Result;
                    handler(result);
                });
            }, null, function() {
                _.each(batch, function() {
                    if (batch.errorHandler) batch.errorHandler();
                });
            });

    };

    QueryDispatcher.prototype.dispatch = function (queryName, handler, decorateDataFunc, errorHandler) {
        this.dispatchBatch([{
            queryName: queryName,
            handler: handler,
            decorateDataFunc: decorateDataFunc,
            errorHandler: errorHandler
        }]);
    };

    QueryDispatcher.prototype.backgroundDispatch = function (queryName, handler, decorateDataFunc, errorHandler) {
        var requestData = this.getQueryRequest([{
            queryName: queryName,
            decorateDataFunc: decorateDataFunc
        }]);
        this.piping.dispatcher
            .backgroundDispatch(processEventActionsUrl.get(this.piping, 'Queries'), requestData, function (batchResult) {
                handler(batchResult.responses[0].Results[0].Result);
            }, null, errorHandler || $.noop)
            .catch(function () { });
    };

    return QueryDispatcher;
});

